import { __module as toPrimitive } from '../../../../_virtual/toPrimitive.js';
import './typeof.js';
import { exports as _typeofExports } from '../../../../_virtual/typeof.js';

(function (module) {
	var _typeof = _typeofExports["default"];
	function toPrimitive(t, r) {
	  if ("object" != _typeof(t) || !t) return t;
	  var e = t[Symbol.toPrimitive];
	  if (void 0 !== e) {
	    var i = e.call(t, r || "default");
	    if ("object" != _typeof(i)) return i;
	    throw new TypeError("@@toPrimitive must return a primitive value.");
	  }
	  return ("string" === r ? String : Number)(t);
	}
	module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (toPrimitive));
//# sourceMappingURL=toPrimitive.js.map
